/* Progressive enhancement: wrap existing description content in <details>. */
(function () {
  "use strict";

  function getPageTitle() {
    var h1 = document.querySelector("h1");
    if (!h1) {
      return "";
    }
    return h1.textContent.trim();
  }

  function isBlankText(node) {
    return !node || !node.textContent || !node.textContent.trim();
  }

  function createIcon() {
    var icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("aria-hidden", "true");
    icon.setAttribute("focusable", "false");
    icon.setAttribute("class", "icon icon-caret");
    icon.setAttribute("viewBox", "0 0 10 6");
    
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("fill", "currentColor");
    path.setAttribute("fill-rule", "evenodd");
    path.setAttribute("clip-rule", "evenodd");
    path.setAttribute("d", "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708");
    
    icon.appendChild(path);
    return icon;
  }

  function ensureIcon(details) {
    if (!details) {
      return;
    }

    var summary = details.querySelector("summary");
    if (!summary || summary.querySelector(".icon-caret")) {
      return;
    }

    summary.appendChild(createIcon());
  }

  function wrapInAccordion(target, baseTitle) {
    if (!target || target.dataset.seoAccordion === "1" || isBlankText(target)) {
      return;
    }

    // Add theme class for styling container
    // Using custom class to ensure specific styling (borders, margins, arrows) without conflicts
    target.classList.add("seo-accordion", "content-container");

    var existingDetails = target.querySelectorAll("details.seo-details");
    if (existingDetails.length) {
      for (var i = 0; i < existingDetails.length; i += 1) {
        ensureIcon(existingDetails[i]);
      }
      target.dataset.seoAccordion = "1";
      return;
    }

    var pageTitle = getPageTitle();
    var titleText = pageTitle ? baseTitle + ": " + pageTitle : baseTitle;

    var details = document.createElement("details");
    details.className = "seo-details";

    var summary = document.createElement("summary");
    // Theme structure for alignment and spacing
    
    var summaryDiv = document.createElement("div");
    summaryDiv.className = "summary__title";

    var title = document.createElement("h3");
    title.className = "accordion__title inline-richtext h4";
    title.style.margin = "0"; // Ensure standard spacing
    title.textContent = titleText;
    
    
    summaryDiv.appendChild(title);
    summary.appendChild(summaryDiv);
    summary.appendChild(createIcon());

    var content = document.createElement("div");
    content.className = "accordion__content rte";
    
    // Move existing children into content div
    while (target.firstChild) {
      content.appendChild(target.firstChild);
    }

    details.appendChild(summary);
    details.appendChild(content);
    target.appendChild(details);
    target.dataset.seoAccordion = "1";
  }

  function init() {

//  wrapInAccordion(
//  document.querySelector(".product__description"),
// "Descrição do produto"
//  );

    var collectionDescriptions = document.querySelectorAll(
      ".collection-hero__description, .collection__description"
    );
    for (var i = 0; i < collectionDescriptions.length; i += 1) {
      wrapInAccordion(collectionDescriptions[i], "Descrição da coleção");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
